module.exports = __webpack_public_path__ + "media/images/cooking-6f767716a6292e464666e03f01ca0721.jpg";